import { SurveyLogicElement, SurveyLogicOperator, SurveyLogicRule } from '@vision/ui/interfaces/survey-logic-builder';
import { getLabel } from '@vision/ui/utils/business/survey-element.utils';

type ConditionPreview = {
  id: string;
  groupId: string;
  values: string[];
  conditionOperator: SurveyLogicOperator;
  valueOperator?: SurveyLogicOperator;
};

export function getConditionPreviews(
  rule: SurveyLogicRule,
  elements: SurveyLogicElement[],
  activeLanguageCode: string,
): ConditionPreview[] {
  const elementsByKey = new Map(elements.map((element) => [element.key, element]));

  return rule.conditionGroups.flatMap((group) =>
    group.conditions.flatMap((condition) => {
      let values: string[];
      let valueOperator: SurveyLogicOperator | undefined;

      if (condition.controlType === 'value') {
        const answerValue = condition.answerValue?.trim();

        if (!answerValue) {
          return [];
        }

        values = [answerValue];
      } else {
        const selectedOptionKeys = condition.optionKeys?.length
          ? condition.optionKeys
          : condition.optionKey
            ? [condition.optionKey]
            : [];
        const validOptionKeys = selectedOptionKeys.filter(Boolean);

        if (validOptionKeys.length === 0) {
          return [];
        }

        const elementKey = condition.elementKey || condition.triggerRef?.elementKey || condition.source?.elementKey;
        const element = elementKey ? elementsByKey.get(elementKey) : undefined;

        values = validOptionKeys.map((keyOrLabel) => {
          const option = element?.detail?.options?.find(
            (candidate) => candidate.key === keyOrLabel || Object.values(candidate.body || {}).includes(keyOrLabel),
          );

          return option ? getLabel(option.body, activeLanguageCode, option.key) : keyOrLabel;
        });
        valueOperator = condition.optionKeysOperator || 'and';
      }

      return [
        {
          id: condition.id,
          groupId: group.id,
          values,
          conditionOperator: group.operator,
          ...(valueOperator && { valueOperator }),
        },
      ];
    }),
  );
}
